import { render, staticRenderFns } from "./V2DeleteCollectionModal.vue?vue&type=template&id=e9665622&scoped=true&"
import script from "./V2DeleteCollectionModal.vue?vue&type=script&lang=js&"
export * from "./V2DeleteCollectionModal.vue?vue&type=script&lang=js&"
import style0 from "./V2DeleteCollectionModal.vue?vue&type=style&index=0&id=e9665622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9665622",
  null
  
)

export default component.exports